/**
 * Exercice joué par la démo guidée (`/demo`) pour chaque niveau : un essai
 * gratuit de SKILLCARD (1 question, V2) qui a une feuille de brouillon du
 * moteur v2 publiée (`packs`). Choisis pour METTRE EN AVANT LES FONCTIONNALITÉS :
 * on garde, par niveau, l'essai gratuit dont le coach joue le plus de chapitres
 * (erreur classique, valeurs proposées, résultats proposés, bonus au geste) et,
 * quand il en existe un, le passage de l'autre côté du signe égal — balayage des
 * 742 essais gratuits publiés au robot le 31/10/2026. Vérifiés sans compte
 * (RPC `get_exercise_v2_demo` + `get_scratch_models_demo`, migration 0506).
 * Changer un exercice = remplacer son id ici (mêmes conditions) : le coach le
 * guide tout seul s'il sait le mener jusqu'à la bonne réponse, marquée par le
 * brouillon (sinon la question se joue sans guide). Le test
 * `guided/coach.test.ts` rejoue les feuilles de ces exercices.
 */

import type { SchoolLevel } from '@jeraisonne/db';

export const DEMO_EXERCISE_BY_LEVEL = {
  /** L'angle manquant : 50° et 70°, le troisième ? — remplacé le 31/10/2026 (le seul 6e qui met en avant
   * les quatre chapitres ET le passage de l'autre côté du signe égal : « C + 120 = 180 » → « C = 180 − 120 ») */
  '6e': 'acfd816e-994b-421b-a9ea-f42db5899764',
  /** Aire du triangle : base 8 cm, hauteur 5 cm */
  '5e': 'a2b239aa-2b7e-42d2-8ac2-f277702914c5',
  /** Calculs avec Pythagore : AB = 6, AC = 8, BC = ? */
  '4e': 'c289d06e-b49f-45af-b6a7-4e9191987b44',
  /** Calculs avec Thalès : MN = ? */
  '3e': '790c6226-eda1-4475-b424-48b3f07a4680',
  /** Déterminant : u⃗(2 ; 3), v⃗(4 ; 6) — remplacé le 29/10/2026 (le milieu de [AB] cherchait deux
   * coordonnées et sa bonne réponse « (4 ; 1) » n'était marquée par aucune valeur de la feuille) */
  '2nde': '6f10640d-bb22-46b0-96b7-96c6629d65ad',
  /** Équations du second degré : Δ = b² − 4ac avec a = 2, b = −3, c = 1 — remplacé le 04/11/2026
   * (le second degré est LA notion de 1re, et son `pred` « Discriminant » porte le Move-savoir du
   * niveau : la formule n'est pas dans l'énoncé, elle se prend dans la trousse) */
  '1re': 'cb7fda72-3202-4761-8a56-2f67a30b8401',
  /** Point fixe d'une suite récurrente : ℓ = 0,5ℓ + 3 — remplacé le 31/10/2026 (même raison, et 8 étapes
   * de moins que la distance dans le plan complexe) */
  tle: '70003bd0-e95e-4df3-93e8-9fab5a865529',
} as const satisfies Partial<Record<SchoolLevel, string>>;

/** Exercice de démo du niveau, ou null (niveau sans démo). PUR. */
export function demoExerciseFor(level: SchoolLevel): string | null {
  return (DEMO_EXERCISE_BY_LEVEL as Partial<Record<SchoolLevel, string>>)[level] ?? null;
}
